import {IBaseEntity, BaseEntity} from 'app/blocks/model/base-entity.model';
import {MposDate} from 'app/blocks/util/mpos-date';

export interface IOrderPriority extends IBaseEntity {
    id?: number;

    code?: string;

    description?: string;
}

export class OrderPriority extends BaseEntity implements IOrderPriority {
    public id?: number;

    public code?: string;

    public description?: string;

    constructor(orderPriority?) {
        super();
        if (orderPriority) {
            this.id = orderPriority.id;

            this.code = orderPriority.code;

            this.description = orderPriority.description;
        } else {
        }
    }

    get discriminator(): any {
        return this.id;
    }

    clone(): OrderPriority {
        return new OrderPriority(this);
    }
}
